<template>
    <transition-group
        tag="div"
        name="animation-list__drop-in-"
        class="betslip__system-box"
    >
        <SystemCheckbox
            v-for="system in systems"
            :key="system.toString()"
            :system="system"
            :label="getLabel(system)"
            :disabled="isDisabled"
            @systemClick="onSystemClick"
        />
    </transition-group>
</template>

<script>
    import SystemCheckbox from './SystemCheckbox';

    export default {
        name: 'Systems',
        props: {
            systems: {
                type: Array,
                required: true
            },
            fixedSelectionsCount: {
                type: Number,
                required: true
            },
            isDisabled: {
                type: Boolean,
                required: false,
                default: false
            },
        },
        methods: {
            getLabel(system) {
                const fixedItems = this.fixedSelectionsCount;

                if (fixedItems) {
                    return `${fixedItems}F${system.toString()}`;
                }

                return system.toString();
            },
            onSystemClick(system) {
                this.$emit('systemClick', system);
            }
        },
        components: {
            SystemCheckbox,
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/betSlip/Systems.vue